import React from 'react';

export default function Header({
  theme,
  userProfile,
  selectedDay,
  isDark,
  setIsDark,
  setShowSettingsModal,
  setShowPaywallModal,
  isDeveloper,
  isPro,
  isTrialActive,
  trialDaysLeft,
  isNightCheckTime
}) {
  return (
    <header className={`sticky top-0 z-40 ${theme.navBg} backdrop-blur-xl border-b ${theme.border} px-6 py-4 flex flex-col gap-2 transition-colors duration-500`}>
      <div className="flex justify-between items-center">
        <div>
          <span className={`text-[9px] font-bold tracking-[0.2em] ${theme.muted} uppercase block mb-1`}>ATLETA: {userProfile?.name || 'Atleta'}</span>
          <h1 className="text-xl font-black tracking-tight flex items-center gap-2">
            STUDIO <span className={`text-[10px] px-3 py-1 rounded-full border ${theme.border} ${theme.muted} font-bold uppercase tracking-widest`}>DÍA {selectedDay}</span>
          </h1>
        </div>
        <div className="flex items-center gap-2">
          <button onClick={() => setIsDark(!isDark)} className={`p-2.5 ${theme.secondary} rounded-full text-[12px]`}>{isDark ? '☀️' : '🌙'}</button>
          <button type="button" aria-label="Mi perfil" onClick={() => setShowSettingsModal(true)} className={`p-2.5 ${theme.secondary} rounded-full text-[12px]`}>Mi perfil</button>
          <button 
            onClick={() => setShowPaywallModal(true)} 
            className={`px-4 py-2 rounded-full text-[10px] font-bold uppercase tracking-widest border transition-all ${isDeveloper ? 'bg-purple-600 text-white border-transparent' : isPro ? 'bg-green-500 text-black border-transparent' : isTrialActive ? 'bg-blue-600 text-white border-transparent' : 'bg-red-600 text-white border-transparent'}`}
          >
            {isDeveloper ? 'DEV VIP' : isPro ? 'VIP PRO' : isTrialActive ? `PRO (${trialDaysLeft}d gratis)` : 'SUSCRIBIRSE'}
          </button>
        </div>
      </div>

      {isNightCheckTime && (
        <div className="bg-amber-500/10 border border-amber-500/30 p-2.5 rounded-2xl flex items-center justify-between text-[10px] text-amber-500 font-bold animate-pulse">
          <span>🌙 23:00 hrs: Hora del cierre diario. ¡Registra tus pasos y entreno!</span>
          <span className="text-xs">⏳</span>
        </div>
      )}
    </header>
  );
}
